import { useTheme } from "../../../../app/providers/ThemeProvider";
import logodark from "../../../../assets/images/Tencotics,logo-02.png";
import logolight from "../../../../assets/images/Tencotics,logo-04.png";
import "./Footer.css";
import { RiWhatsappLine, RiInstagramLine, RiLinkedinBoxLine, RiMapPinLine } from 'react-icons/ri';

const Footer = () => {
  const { theme } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`footer ${theme === "dark" ? "footer-dark" : "footer-light"}`}>
      <div className="footer-content">
        <div className="footer-logo">
          <img
            src={theme === "dark" ? logodark : logolight}
            alt="Tecnotics Logo"
            className="footer-logo-img"
          />
        </div>
        <div className="footer-columns">
          <div className="footer-col">
            <h3 className="footer-title">Información institucional</h3>
            <ul className="footer-list">
              <li><a href="/quienes-somos">¿Quiénes somos?</a></li>
              <li><a href="/politicas-privacidad">Política de privacidad y tratamiento de datos</a></li>
              <li><a href="/contacto">Trabaja con nosotros</a></li>
              <li><a href="/login">Iniciar sesión</a></li>
            </ul>
          </div>
          <div className="footer-col social-col">
            <h3 className="footer-title">Síguenos</h3>
            <div className="social-icons">
              <a href="https://wa.me/573185078721" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <RiWhatsappLine size={28} color="#25D366"/>
              </a>
              <a href="https://www.instagram.com/tecnotics_sas" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <RiInstagramLine size={28} color="#E4405F"/>
              </a>
              <a href="https://www.linkedin.com/company/tecnotics" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <RiLinkedinBoxLine size={28} color="#0077B5"/>
              </a>
            </div>
          </div>
          <div className="footer-col">
            <h3 className="footer-title">Contáctanos</h3>
            <ul className="footer-list">
              <li className="contact-item">
                <RiMapPinLine className="contact-icon"/>
                <span>Terminal del Sur, Medellín, Colombia</span>
              </li>
              <li><b>Teléfono:</b> +57 318 5078721</li>
              <li><b>Correo:</b> <a href="mailto:Alejandro@tecnotics.com">Alejandro@tecnotics.com</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; {currentYear} Tecnotics. Todos los derechos reservados.
          <span className="privacy-link">
            <a href="/politicas-privacidad">Políticas y Privacidad</a>
          </span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
